import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, restaurantConfig } from 'restaurant'
import { ProductImage, BagIcon, Tags } from 'components'
import { classNames, dayjs, format, toDecimal } from '@dt/fe-utils'
import DiscountTag from '../DiscountTag'
import './index.scss'

interface IProps {
  item: IViewCartItem | IViewOrderDetail | any;
  /** true 待确认 false 已下单 undefined|null 不显示 */
  // isWait?: true | false | undefined | null;
  /** 餐品状态 待下单 待确认 已下单 （无状态） */
  status?: 'WAIT_PLACE' | 'WAIT_CONFRIM' | 'ORDERED' | '';
}

const ProductItem: FC<IProps> = ({ item, status }) => {
  const refundCnt = (item as IViewOrderDetail).refundCnt || 0
  const isAllRefund = (item as IViewOrderDetail).isAllRefund
  const productGroup = (item: IViewCartItem | IViewOrderDetail) => {
    return (
      <div className='item-groups'>
        {
          item.productGroups?.map(group => (
            <div key={group.no} className='item-group'>
              {
                group?.productGroupDetails.map(product => (
                  <div key={product.pk} className='item-group-product'>
                    <div className='product-info'>
                      <strong>{product.name}</strong>
                      <br />
                      <small>{product.optionStr}</small>
                      <div className='product-extra-info'>
                        <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} />
                      </div>
                    </div>
                    <div className='product-cnt'>x {product.cnt}</div>
                  </div>
                ))
              }
            </div>
          ))
        }
      </div>
    )
  }

  const formatDate = (_date) => {
    const date = dayjs(_date)
    const today = dayjs()
    const tomorrow = today.add(1, 'day')
    if (date.isSame(today, 'day')) {
      return date.format('HH:mm')
    } else if (date.isSame(tomorrow, 'day')) {
      return i18n.t('checkout.tomorrow') + ' ' + date.format('HH:mm')
    } else {
      return date.format('MM-DD HH:mm')
    }
  }

  const getItemTimeTxt = useMemo(() => {
    // 远程后付费需要展示预约时间
    const showStartTime = restaurantConfig.codeType === 'brand' && cartMobx.info.payMode
    let startTime = showStartTime ? item.startTime || cartMobx.info.startTime : null
    startTime = startTime && formatDate(startTime)
    try {
      const pickTimeRange = item.pickTimeRange ? JSON.parse(item.pickTimeRange) : null
      if (pickTimeRange?.start && pickTimeRange?.end) {
        startTime = `${dayjs(pickTimeRange?.start).format('MM-DD HH:mm')}-${dayjs(pickTimeRange?.end).format('HH:mm')}`
      }
    } catch (error) {
    }
    return startTime
  }, [item])

  const statusName = useMemo(() => {
    if (!status) return ''
    return isAllRefund && refundCnt ? i18n.t('checkout.refunded') : status === 'WAIT_CONFRIM' ? i18n.t('checkout.unconfirmed') : status === 'ORDERED' ? '' : i18n.t('checkout.unorder')
  }, [item, status])

  const renderItem: any = (isRefund: boolean, totalPrice?: number) => {
    return (
      <div>
        <div
          className={classNames('checkout-product-item', {
            'refund-item': isRefund,
            'ordered-item': status === 'ORDERED',
          })}
        >
          <div className='item-top'>
            <ProductImage color={!item.pic && restaurantConfig.displayMode === 'waterfall' ? item.productNo : ''} width={64} imgSrc={item.pic} cnt={isRefund ? 0 : item.cnt} />
            <div className='item-info'>
              <strong className='item-title'>{!!item.isTogo && <BagIcon size='small' />}{item.name}</strong>
              <br />
              {getItemTimeTxt && (
                <>
                  <span className='item-start-time'>{getItemTimeTxt} {i18n.t(`menu.${cartMobx.info.eatType}`)}</span>
                  <br />
                </>
              )}
              <small>{item.optionStr}</small>
              <div className='product-extra-info'>
                <Tags datas={[...(item.tags || []), ...(item.allergys || [])]} disableSingleSale={!item.isSingleSale} />
              </div>
            </div>
            <div className='product-price'>
              <div className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(totalPrice !== undefined ? totalPrice : item.actualPrice) }}></div>
              {
                isRefund ? null : (
                  <div className='item-discount'>
                    <DiscountTag offItems={item.offItems} />
                  </div>
                )
              }
              {isRefund ? null : item.actualPrice !== item.totalPrice ? <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(item.totalPrice) }}></del> : null}
            </div>
          </div>
          {productGroup(item)}
          {isRefund ? null : (!!item.remark && <div className='remark-txt-wrap'>{i18n.t('cart.singleRemarkTxt')}{item.remark}</div>)}
          {isRefund ? <div className='item-staus'><span><em>{i18n.t('checkout.refunded')}</em></span></div> : !!statusName && <div className='item-staus'><span><em>{statusName}</em></span></div>}
        </div>
      </div>
    )
  }

  return (
    <>
      {!isAllRefund && refundCnt > 0 ? renderItem(true, toDecimal(item.totalPrice / item.cnt * refundCnt, 2)) : null}
      {renderItem(isAllRefund && refundCnt > 0)}
    </>
  )
}

export default observer(ProductItem)
